<template>
    <div class="funcionalidadeSkeleton pulse-bg" :class="type">
    </div>
</template>

<script>
export default {
    name: 'FuncionalidadeSkeleton',
    props: {
        type: String
    },
    data () {
        return {}
    }
}
</script>

<style lang="scss">
.funcionalidadeSkeleton {
    background-color: #f7f7f7;
    border-radius: 4px;
    box-shadow: 2px 2px #ddd;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    animation: pulse-bg 1s infinite;

    &.large {
        width: 344px;
        height: 151px;

        background-image: none;
        background-color: #f7f7f7;
        animation: pulse-bg 1s infinite;
    }
}

.default {
    width: 160px;
    height: 152px;
}

@keyframes pulse-bg {
    0% { background-color: #ddd; }
    50% { background-color: #d0d0d0; }
    100% { background-color: #ddd; }
}



</style>
